import React from 'react';
// import { Link } from 'react-router-dom';
import HomeTopBar from './HomeTopBar'
import ChannelInteractionChart from '../charts/ChannelInteraction/ChannelInteractionChart'


const ChannelInteraction = ({heading}) => {
  return (
    <div className='home'>
    <HomeTopBar/>
    <div className='channel-interaction'>            
      <h3 className='channel-interaction-heading-div'>{heading}</h3>
      <ChannelInteractionChart/>                  
    </div>           
    </div>
  );
};

export default ChannelInteraction;
